import { gql } from "@apollo/client";

export const GET_TIPO_MODULO = gql`
query GetTipoModulo {
    tipoModulos {
        success,
        error,
        valorEsperado {
            idTipoModulo,
            descripcion,
            abreviacion,
            seReporta,
            sePaga,
            forEpi,
            idTipoServicio,
            llevaIndicacion,
            complejidad,
            descripcion2
        }
    }
}`;